import React, { useState, useEffect } from 'react';
import { testConnection } from '../utils/api';

function ApiStatus() {
  const [status, setStatus] = useState({
    loading: true,
    connected: false,
    message: 'Checking connection...',
    lastCheck: null
  });

  const checkApiStatus = async () => {
    setStatus(prev => ({ ...prev, loading: true }));
    
    const result = await testConnection();
    
    setStatus({
      loading: false,
      connected: result.success,
      message: result.message,
      lastCheck: new Date().toLocaleTimeString(),
      duration: result.duration
    });
  };

  useEffect(() => {
    checkApiStatus();
    
    // Check status every 30 seconds
    const interval = setInterval(checkApiStatus, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const getStatusColor = () => {
    if (status.loading) return '#ffa500'; // orange
    return status.connected ? '#4caf50' : '#f44336'; // green or red
  };

  const getStatusIcon = () => {
    if (status.loading) return '⟳';
    return status.connected ? '●' : '●';
  };

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: 'rgba(30, 41, 59, 0.95)',
      border: `2px solid ${getStatusColor()}`,
      borderRadius: '8px',
      padding: '8px 12px',
      fontSize: '12px',
      fontFamily: 'monospace',
      boxShadow: '0 2px 12px rgba(0,0,0,0.4)',
      zIndex: 1000,
      maxWidth: '250px',
      backdropFilter: 'blur(8px)'
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        color: getStatusColor(),
        fontWeight: 'bold'
      }}>
        <span style={{ marginRight: '6px', fontSize: '14px' }}>
          {getStatusIcon()}
        </span>
        API Status
        <button 
          onClick={checkApiStatus}
          style={{
            marginLeft: 'auto',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '12px',
            color: getStatusColor()
          }}
          title="Refresh status"
        >
          ↻
        </button>
      </div>
      <div style={{ 
        color: '#94a3b8', 
        marginTop: '4px',
        fontSize: '11px' 
      }}>
        {status.message}
        {status.lastCheck && (
          <div>Last check: {status.lastCheck}</div>
        )}
        {status.duration && (
          <div>Response time: {status.duration}ms</div>
        )}
      </div>
    </div>
  );
}

export default ApiStatus;
